<template>
  <!-- 待审核用户 -->
  <div class="container_cm">
    <div class="main_cm">
      <div class="bh_cm">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/guidance' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户管理</el-breadcrumb-item>
          <el-breadcrumb-item>待审核用户</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="top_cm">
        <div>
          <span>姓名</span><el-input v-model="searchForm.userName" clearable placeholder="请输入姓名"></el-input>
          <span>账号</span><el-input v-model="searchForm.loginName" clearable placeholder="请输入账号"></el-input>
        </div>
        <div>
          <el-button class="mybtny" v-waves icon="el-icon-search" @click="toSearch">搜索</el-button>
        </div>
      </div>
      <div class="table_cm">
        <Table
          ref="multipleTable"
          v-loading="loading"
          :tableData="List"
          :pageSize='pageSize'
          :currentPage="pageIndex"
          :cloumns="cloumns"
          :totalNum="total"
          :pageFlag='true'
          :selection='false'
          @handleCurrentChange="handleCurrentChange"
        >
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="username"
            label="账号"
            align="center" >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            align="center">
          </el-table-column>
          <el-table-column
            label="申请时间"
            prop="createTime"
            align="center"
            width="300"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="passClick(scope.row)">审核通过</el-button>
              <el-button type="text" @click.native.prevent="stop(scope.row)">注销删除</el-button>
            </template>
          </el-table-column>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, delUser, getCheckInfo } from "@/api/userApi.js";
import Table from "@/components/myTable";
export default {
  inject:['reload'],
  components: {
    Table,
  },
  data() {
    return {
      userInfo: '',
      List: [],
      cloumns: [],
      loading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      searchForm: {},
    }
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取用户列表
    getList() {
      let params = {
        deptId: this.userInfo.deptId,
        lockFlag: 0,
        current: this.pageIndex,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.loading = true;
      getUserInfo(params).then(res => {
        if (res.code == "200") {
          this.List = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg || "服务器连接失败");
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        this.$message.error(err.msg || err.message || "服务器连接失败");
      });
    },
    toSearch() {
      this.pageIndex = 1;
      this.getList();
    },
    reset() {
      this.searchForm.userName = '';
      this.searchForm.loginName = '';
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    // 刷新
    refresh() {
      this.reload();
    },
    //审核通过操作
    passClick(row) {
      getCheckInfo(row.userId).then(res => {
        if (res.code == '200') {
          this.$message({
            message: `${row.name} 审核通过！ `,
            showClose: true,
            type: 'success'
          });
          this.getList();
        } else{
          this.$message.error(`操作失败！`)
        }
      })
      .catch(err => {
        console.error(err);
      })
    },
    //注销删除操作
    stop(row) {
      this.$confirm(`确定注销 <strong style="color: #fffe4f">${row.name}</strong> 用户吗?`, '注销提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning',
      }).then(() => {
        delUser(row.userId).then(res => {
          if (res.code == "200") {
            this.$message(`${row.name} 已删除`);
            this.getList()
          } else {
            this.$message.error(`删除失败`)
            this.getList()
          }
        })
      }).catch(() => {});
    },
  },
}
</script>

<style lang="less" scoped>
.container_cm {
  width: 100%;
  height: calc(100% - 30px);
  padding: 15px 0;
  .main_cm {
    height: calc(100% - 82px);
    margin: 0 auto;
    .bh_cm {
      height: 20px;
      line-height: 20px;
    }
    .top_cm {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 200px;
        margin: 0 20px;
      }
      .el-button {
        width: 140px;
        margin-left: 20px;
      }
      .el-select {
        margin: 0 20px;
      }
    }
    .table_cm {
      height: 100%;
      /deep/.el-table td {
        font-size: 14px;
      }
      .el-button {
        margin: 0 20px;
      }
    }
    .pages {
      width: 1200px;
      margin-top: 30px;
      margin-bottom: 20px;
      .a {
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/usermanage/checkingUser.vue